export const GET_PROMOEVENTS_START = 'GET_PROMOEVENTS_START';
export const GET_PROMOEVENTS_SUCCESS = 'GET_PROMOEVENTS_SUCCESS';
export const GET_PROMOEVENTS_FAILED = 'GET_PROMOEVENTS_FAILED';

export const RESET_PROMOEVENTS = 'RESET_PROMOEVENTS';
